import { render, staticRenderFns } from "./SectionBackground.vue?vue&type=template&id=1bcacd2e&scoped=true&"
import script from "./SectionBackground.vue?vue&type=script&lang=js&"
export * from "./SectionBackground.vue?vue&type=script&lang=js&"
import style0 from "./SectionBackground.vue?vue&type=style&index=0&id=1bcacd2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcacd2e",
  null
  
)

export default component.exports